/**
 * Blog → trackable outing (when we monitor cancellations on that resource).
 * Keep display names in sync with nature-backend/src/constants.js BLOG_TO_OUTING_MAP.
 * Add `path` when the outing has a stable permalink; otherwise use searchPath.
 */
export const blogToOutingMap = {
  'phantom-ranch-grand-canyon-guide': {
    name: 'Phantom Ranch',
    slug: 'phantom-ranch',
    searchPath: '/?name=Phantom%20Ranch',
  },
  'synchronous-fireflies-smokies-guide': {
    name: 'Elkmont Campground',
    slug: 'elkmont-campground',
    path: '/campground/tennessee/great-smoky-mountains-national-park/elkmont-campground',
  },
  'curry-village-guide': {
    name: 'Curry Village',
    slug: 'curry-village',
    path: '/hotel/california/yosemite-national-park/curry-village',
  },
  'firefall-yosemite-guide': {
    name: 'Upper Pines Campground',
    slug: 'upper-pines-campground',
    path: '/campground/california/yosemite-national-park/upper-pines-campground',
  },
  'yosemite-moonbow-guide': {
    name: 'Upper Pines Campground',
    slug: 'upper-pines-campground',
    path: '/campground/california/yosemite-national-park/upper-pines-campground',
  },
  'blue-ghost-fireflies-guide': {
    name: 'Elkmont Campground',
    slug: 'elkmont-campground',
    path: '/campground/tennessee/great-smoky-mountains-national-park/elkmont-campground',
  },
  'cadillac-mountain-sunrise-guide': {
    name: 'Blackwoods Campground',
    slug: 'blackwoods-campground',
    searchPath: '/?name=Blackwoods',
  },
  'going-to-the-sun-road-opening-guide': {
    name: 'Sperry Chalet',
    slug: 'sperry-chalet',
    path: '/campground/montana/glacier-national-park/sperry-chalet',
  },
  'mount-whitney-permits-guide': {
    name: 'Mount Whitney',
    slug: 'mount-whitney',
    searchPath: '/?name=Mount%20Whitney',
  },
  'inyo-national-forest-guide': {
    name: 'Mount Whitney',
    slug: 'mount-whitney',
    path: '/permit/california/inyo-national-forest/mt-whitney-0001',
  },
  'kalalau-trail-permits-guide': {
    name: 'Kalalau Trail',
    slug: 'napali-coast-state-wilderness-park-kalalau',
    searchPath: '/?name=Kalalau',
  },
  'glacier-chalets-guide': {
    name: 'Sperry Chalet',
    slug: 'sperry-chalet',
    path: '/campground/montana/glacier-national-park/sperry-chalet',
  },
  'steep-ravine-cabins-guide': {
    name: 'Steep Ravine Cabins',
    slug: 's-rav-cabin-area',
    path: '/campground/california/mount-tamalpais-sp/s-rav-cabin-area',
  },
  'crystal-cove-cottages-guide': {
    name: 'Crystal Cove Beach Cottages',
    slug: 'beach-cottages',
    path: '/campground/california/crystal-cove-sp-beach-cottages/beach-cottages',
  },
  'big-sur-environmental-campsites-guide': {
    name: 'Julia Pfeiffer Burns Environmental Sites',
    slug: 'environmental-group-camp-area',
    path: '/campground/california/julia-pfeiffer-burns-sp/environmental-group-camp-area',
  },
  'bahia-honda-state-park-camping-guide': {
    name: 'Bahia Honda State Park Camping',
    slug: 'bahia-honda-state-park-camping',
    path: '/campground/florida/bahia-honda-state-park/bahia-honda-state-park-camping',
  },
  'highlands-hammock-state-park-camping-guide': {
    name: 'Highlands Hammock State Park Camping',
    slug: 'highlands-hammock-state-park-camping',
    path: '/campground/florida/highlands-hammock-state-park/highlands-hammock-state-park-camping',
  },
  'st-george-island-state-park-camping-guide': {
    name: 'St. George Island State Park Camping',
    slug: 'dr-julian-g-bruce-st-george-island-state-park-camping',
    path: '/campground/florida/dr-julian-g-bruce-st-george-island-state-park/dr-julian-g-bruce-st-george-island-state-park-camping',
  },
  'garner-state-park-camping-guide': {
    name: 'Garner State Park Campground',
    slug: 'garner-state-park-campground',
    path: '/campground/texas/garner-state-park/garner-state-park-campground',
  },
  'arizona-state-parks-camping': {
    name: 'Lost Dutchman Camping',
    slug: 'lost-dutchman-camping',
    path: '/campground/arizona/lost-dutchman-state-park/lost-dutchman-camping',
  },
  'lost-dutchman-state-park-camping': {
    name: 'Lost Dutchman Camping',
    slug: 'lost-dutchman-camping',
    path: '/campground/arizona/lost-dutchman-state-park/lost-dutchman-camping',
  },
  'kartchner-caverns-cave-tours': {
    name: 'Kartchner Caverns Big Room Tour',
    slug: 'kartchner-caverns-big-room-tour',
    path: '/permit/arizona/kartchner-caverns-state-park/kartchner-caverns-big-room-tour',
  },
  'alta-via-1-rifugios-booking-guide': {
    name: 'Alta Via 1 (Dolomites)',
    slug: 'alta-via-1-dolomites',
    path: '/recarea/veneto-south-tyrol/alta-via-1-dolomites',
  },
  'alta-via-1-itinerary-planner': {
    name: 'Alta Via 1 (Dolomites)',
    slug: 'alta-via-1-dolomites',
    path: '/recarea/veneto-south-tyrol/alta-via-1-dolomites',
  },
  'milford-track-booking-guide': {
    name: 'Milford Track',
    slug: 'milford-track',
    searchPath: '/?name=Milford%20Track',
  },
  'routeburn-track-guide': {
    name: 'Routeburn Track',
    slug: 'routeburn-track',
    searchPath: '/?name=Routeburn%20Track',
  },
  'kepler-track-guide': {
    name: 'Kepler Track',
    slug: 'kepler-track',
    searchPath: '/?name=Kepler%20Track',
  },
  'tongariro-northern-circuit-guide': {
    name: 'Tongariro Northern Circuit',
    slug: 'tongariro-northern-circuit',
    searchPath: '/?name=Tongariro%20Northern%20Circuit',
  },
  'abel-tasman-track-guide': {
    name: 'Abel Tasman Coast Track',
    slug: 'abel-tasman-coast-track',
    searchPath: '/?name=Abel%20Tasman%20Coast%20Track',
  },
  'heaphy-track-guide': {
    name: 'Heaphy Track',
    slug: 'heaphy-track',
    searchPath: '/?name=Heaphy%20Track',
  },
  'rakiura-track-guide': {
    name: 'Rakiura Track',
    slug: 'rakiura-track',
    searchPath: '/?name=Rakiura%20Track',
  },
  'paparoa-track-guide': {
    name: 'Paparoa Track',
    slug: 'paparoa-track',
    searchPath: '/?name=Paparoa%20Track',
  },
  'lake-waikaremoana-track-guide': {
    name: 'Lake Waikaremoana Track',
    slug: 'lake-waikaremoana-track',
    searchPath: '/?name=Lake%20Waikaremoana',
  },
  'whanganui-journey-guide': {
    name: 'Whanganui Journey',
    slug: 'whanganui-journey',
    searchPath: '/?name=Whanganui%20Journey',
  },
  'great-walks-booking-calendar-2026-2027': {
    name: 'Great Walks',
    slug: 'milford-track',
    searchPath: '/?name=Great%20Walk',
  },
  'great-walks-cancellations': {
    name: 'Great Walks',
    slug: 'milford-track',
    searchPath: '/?name=Great%20Walk',
  },
  'milford-track-cancellations': {
    name: 'Milford Track',
    slug: 'milford-track',
    searchPath: '/?name=Milford%20Track',
  },
  'routeburn-track-cancellations': {
    name: 'Routeburn Track',
    slug: 'routeburn-track',
    searchPath: '/?name=Routeburn%20Track',
  },
  'kepler-track-cancellations': {
    name: 'Kepler Track',
    slug: 'kepler-track',
    searchPath: '/?name=Kepler%20Track',
  },
};

/**
 * Blogs that attract tracker intent but don't have a crawler/outing yet.
 * Exit-intent and in-page CTAs should surface these instead of the homepage.
 */
export const blogTrackAlternatives = {
  'cumberland-falls-moonbow-guide': {
    headline: "Cumberland Falls tracking isn't live yet",
    subhead:
      'DuPont Lodge is closed for renovation through fall 2026, and Kentucky State Parks reservations are not on ReserveNature yet. These rare-experience spots we do monitor sell out just as fast:',
    alternatives: [
      {
        name: 'Elkmont Campground',
        description: 'Great Smoky Mountains synchronous fireflies — peak dates vanish in minutes',
        path: '/campground/tennessee/great-smoky-mountains-national-park/elkmont-campground',
      },
      {
        name: 'Phantom Ranch',
        description: 'Grand Canyon lodge beds — lottery sellouts with steady cancellations',
        path: '/blogs/phantom-ranch-grand-canyon-guide',
      },
      {
        name: 'Upper Pines Campground',
        description: 'Base camp for Yosemite Firefall — February dates go fast',
        path: '/campground/california/yosemite-national-park/upper-pines-campground',
      },
    ],
    bookDirectUrl:
      'https://parks.ky.gov/corbin/parks/resort/cumberland-falls-state-resort-park',
    bookDirectLabel: 'Book Cumberland Falls on Kentucky State Parks',
  },
};

export function getBlogTrackAlternatives(blogSlug) {
  return blogTrackAlternatives[blogSlug] ?? null;
}

export function getBlogOuting(blogSlug) {
  return blogToOutingMap[blogSlug] ?? null;
}

export function getOutingLink(entry) {
  if (!entry) return '/';
  return entry.path || entry.searchPath || '/';
}
